module.exports = __webpack_public_path__ + "static/media/narrativ_text_2.ec15a838.svg";